"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var mobx_react_1 = require("mobx-react");
var api_1 = __importStar(require("api"));
var use_stores_1 = require("hooks/use-stores");
var use_notification_1 = require("hooks/use-notification");
var Modal_1 = __importDefault(require("components/modal/Modal"));
var TextInput_1 = __importDefault(require("components/common/inputs/TextInput"));
var Notification_1 = require("components/Notification");
var Button_1 = __importDefault(require("components/common/buttons/Button"));
var Loading_1 = __importDefault(require("components//Loading"));
var done_icon_dark_svg_1 = __importDefault(require("res/img/done-icon-dark.svg"));
var AddUser = mobx_react_1.observer(function () {
    var _a = react_1.useState({}), data = _a[0], setData = _a[1];
    var _b = react_1.useState(false), success = _b[0], setSuccess = _b[1];
    var _c = use_stores_1.useStores(), allUserStore = _c.allUserStore, apiStore = _c.apiStore;
    var history = react_router_dom_1.useHistory();
    var notification = use_notification_1.useNotification();
    var busy = apiStore.data.busyRoutes.includes('/users');
    var redirectTimerRef = react_1.useRef(null);
    var changeHandler = function (e) {
        var _a;
        setData(__assign(__assign({}, data), (_a = {}, _a[e.currentTarget.name] = e.currentTarget.value, _a)));
    };
    var submitHandler = function () {
        var error = null;
        if (!data.password || data.password.length <= 0)
            error = 'Please enter a password';
        if (data.password && data.password.length < 8)
            error = 'Password must be 8 characters or longer';
        if (!data.emailAddress || data.emailAddress.length <= 0)
            error = 'Please enter an email address';
        if (!data.lastName || data.lastName.length <= 0)
            error = 'Please enter a last name';
        if (!data.firstName || data.firstName.length <= 0)
            error = 'Please enter a first name';
        if (error !== null) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: error
            });
            return;
        }
        api_1.default.addUser(data)
            .then(function (response) {
            setSuccess(true);
            allUserStore.addDataItem(response.data);
            redirectTimerRef.current = setTimeout(function () {
                history.replace('/users');
            }, 2000);
        }).catch(api_1.catchHandler);
    };
    return (react_1.default.createElement(Modal_1.default, { title: 'Add a User' },
        react_1.default.createElement("div", { className: 'add-user form' },
            react_1.default.createElement("div", { className: 'flex flex-row' },
                react_1.default.createElement(TextInput_1.default, { type: 'text', name: 'firstName', placeholder: 'First Name', autoFocus: true, value: data.firstName || '', onChange: changeHandler }),
                react_1.default.createElement(TextInput_1.default, { type: 'text', name: 'lastName', placeholder: 'Last Name', value: data.lastName || '', onChange: changeHandler })),
            react_1.default.createElement(TextInput_1.default, { type: 'email', name: 'emailAddress', placeholder: 'Email Address', value: data.emailAddress || '', onChange: changeHandler }),
            react_1.default.createElement(TextInput_1.default, { type: 'password', name: 'password', placeholder: 'Password', value: data.password || '', onChange: changeHandler }),
            react_1.default.createElement(Button_1.default, { title: 'Add User', icon: busy ? react_1.default.createElement(Loading_1.default, null) : success ? react_1.default.createElement("img", { src: done_icon_dark_svg_1.default, alt: 'Done' }) : null, onClick: submitHandler }, "Add User"))));
});
exports.default = AddUser;
